import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ExclamationMarkIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8 14C7.28305 14 6.7019 13.4187 6.7019 12.7019C6.7019 11.985 7.28305 11.4038 8 11.4038C8.71695 11.4038 9.2981 11.985 9.2981 12.7019C9.2981 13.4187 8.71695 14 8 14Z" }),
        React.createElement("path", { d: "M9.0965 1.01562H6.90347C6.57047 1.01562 6.30863 1.31258 6.33651 1.65865L6.90347 10.0266C6.92828 10.3337 7.17468 10.5701 7.47044 10.5701H8.52952C8.82529 10.5701 9.07169 10.3337 9.09649 10.0266L9.66347 1.65865C9.69136 1.31258 9.42951 1.01562 9.0965 1.01562Z" })));
};

export { ExclamationMarkIcon };
//# sourceMappingURL=ExclamationMarkIcon.esm.js.map
